import "./authTravelShell.css";

const AuthTravelShell = ({
  children,
  eyebrow,
  title,
  description,
  ticketCode,
}) => {
  return (
    <section className="travel-auth">
      <img
        className="travel-auth__topography"
        src="/travel-theme/topography-coral.webp"
        alt=""
        aria-hidden="true"
      />
      <img
        className="travel-auth__clouds"
        src="/travel-theme/clouds.webp"
        alt=""
        aria-hidden="true"
      />

      <div className="travel-auth__layout">
        <div className="travel-auth__story">
          <div className="travel-auth__brand-lockup">
            <img
              className="travel-auth__stamp-logo"
              src="/travel-theme/stamp-logo-clean.webp"
              alt="HackPrinceton"
            />
            <div>
              <p className="travel-auth__season">Fall 2026</p>
              <p className="travel-auth__tagline">Buckle up.</p>
            </div>
          </div>

          <div className="travel-auth__intro">
            <p className="travel-auth__eyebrow">{eyebrow}</p>
            <h1>{title}</h1>
            <p className="travel-auth__description">{description}</p>
          </div>

          <div className="travel-auth__route">
            <div>
              <span>From</span>
              <strong>Your campus</strong>
            </div>
            <span aria-hidden="true">→</span>
            <div>
              <span>To</span>
              <strong>Princeton, NJ</strong>
            </div>
            <div>
              <span>Flight</span>
              <strong>HP26</strong>
            </div>
          </div>

        </div>

        <div className="travel-auth__ticket-wrap">
          <article className="travel-auth__ticket">
            <header className="travel-auth__ticket-header">
              <div>
                <span>Boarding pass</span>
                <strong>HackPrinceton</strong>
              </div>
              <div className="travel-auth__ticket-code">
                <span>Route</span>
                <strong>{ticketCode}</strong>
              </div>
            </header>

            <div className="travel-auth__ticket-body">{children}</div>

            <footer className="travel-auth__ticket-footer">
              <span>HP26</span>
              <span aria-hidden="true">••••••••••••</span>
              <span>PTON</span>
            </footer>
          </article>

          <p className="travel-auth__eligibility-note">
            Email ownership is confirmed before an account is created.
            Student details are collected in the application.
          </p>
        </div>
      </div>

      <img
        className="travel-auth__city"
        src="/travel-theme/city-blue.webp"
        alt=""
        aria-hidden="true"
      />
    </section>
  );
};

export default AuthTravelShell;
